export const SOURCE_BBB = 'bbb';
export const SOURCE_YAPILY = 'yapily';

export const SOURCES = [SOURCE_BBB, SOURCE_YAPILY];
